import { createTheme } from '@mui/material/styles';

export const main_theme = createTheme({
  palette: {
    mode: 'light',
    primary: { light: '#99c143', main: '#60973c', dark: '#2c683a' },
    secondary: { light: '#ba68c8', main: '#fcbb18' },
    error: { main: '#f58787' },
    divider: '#99c143'
  },
});